import css from '@utils/css'
import useMods from '@hooks/useMods'
import PropTypes from 'prop-types'
import React from 'react'

const PricingTogglePointer = ({ mods={}, style={}, className: classNameTail }) => {
    const { className } = useMods(PricingTogglePointer, { mods })

    return (
        <div
            className={ css(className, classNameTail) }
            style={ style }
        ></div>
    )
}

PricingTogglePointer.displayName = 'Pricing-Toggle__Pointer'

PricingTogglePointer.propTypes = {
    children: PropTypes.node,
    mods: PropTypes.object,
    style: PropTypes.object
}

export default PricingTogglePointer
